const FormFieldSelect = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  renderOptions,
  isDisabled,
  errorMessage,
  className,
  ...props
}) => {
  return (
    <div className="input-container">
      <label htmlFor={name}>{label}</label>
      <select
        id={name}
        name={name}
        value={value}
        disabled={isDisabled || false}
        onChange={(e) => onChange(e)}
        className={className}
        {...props}
      >
        <option value="">{placeholder}</option>
        {renderOptions()}
      </select>
      <div className="error-msg">{errorMessage}</div>
    </div>
  );
};

export default FormFieldSelect;
